import { css } from 'styled-components';

export const PageTypePdp = css`
  .site-content {
    overflow: visible;
  }

  .site-content > .container {
    max-width: 100%;
    padding: 0;
  }

  &.with-scrolled .site-header {
    opacity: 0;
  }

  .tableel th {
    font-weight: inherit;
  }
`;
